import {
  CampaignConfigDto,
} from '@coretava/api/ecommerce-service';
import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Trans, useTranslation } from '@gamiphy/react-i18n';
import { observer } from 'mobx-react';
import { CampaignUserStore } from '@gamiphy/loyalty-station-desktop/store/campaignUsers';
import { DisplayString, getDisplayStringValue } from '@gamiphy/i18n';
import bogo from './assets/bogo.svg';

type Props = {
  campaign: CampaignConfigDto,
  textAlign?: 'center' | 'left'
}

const BogoCampaign: React.FC<Props> = ({ campaign, textAlign }) => {
  const { t, i18n } = useTranslation();

  const onlyIdenticalBuySkus = React.useMemo(() => (
    CampaignUserStore.bogoCampaignBuyProducts
      ?.map((prod) => prod.name && getDisplayStringValue(i18n, prod.name as DisplayString))
      .join(` ${t('or', 'or')} `)
  ), [CampaignUserStore.bogoCampaignBuyProducts, campaign, i18n]);

  const nonIdenticalbuySkus = React.useMemo(
    () => CampaignUserStore.bogoCampaignBuyProducts
      ?.map((prod) => prod.name && getDisplayStringValue(i18n, prod.name as DisplayString))
      .join(` ${t('referral.tab.reward.and.postfix', 'and')}/${t('or', 'or')} `),
    [CampaignUserStore.bogoCampaignBuyProducts, campaign, i18n],
  );

  const buySkus = React.useMemo(() => {
    if (campaign.rewardConfig?.bogo?.considerIdenticalItems) {
      return onlyIdenticalBuySkus;
    }
    return nonIdenticalbuySkus;
  }, [onlyIdenticalBuySkus, nonIdenticalbuySkus, campaign]);

  const rewardSku = React.useMemo(
    () => CampaignUserStore.bogoCampaignGetProduct && `${campaign.rewardConfig?.bogo?.quantitySelectable} ${getDisplayStringValue(i18n, CampaignUserStore.bogoCampaignGetProduct?.name as DisplayString)}`,
    [i18n, CampaignUserStore.bogoCampaignGetProduct, campaign],
  );

  return (
    <Box display="flex" flexDirection="column" gap={1.5}>
      <Box component="img" src={bogo} alignSelf="center" />
      <Typography fontSize="1.6rem" fontWeight={700} textAlign={textAlign ?? 'left'} width="100%">
        🛍️
        {' '}
        <Trans
          i18nKey="discounts.bogo.item.description"
          defaults="Buy {{buySkusQuantity}} of {{buySkus}}, Get {{getSkus}}"
          values={{
            buySkus,
            getSkus: rewardSku,
            buySkusQuantity: campaign.rewardConfig?.bogo?.minimumQuantityBuyTogether,
          }}
        />
        {' '}
        🎉✨
      </Typography>
      <Typography fontSize="1.4rem" textAlign={textAlign ?? 'left'} width="100%">
        <Trans
          i18nKey="discounts.bogo.unlock"
          defaults="🎁 Unlock your free gift when you purchase {{buySkus}}!"
          values={{
            buySkus,
          }}
        />
      </Typography>
      <Typography fontSize="1.4rem" color="#7B7B7B" textAlign={textAlign ?? 'left'} width="100%">
        <Trans
          i18nKey="discounts.bogo.validFor"
          defaults="Valid for {{validity}} days"
          values={{
            validity: campaign.rewardConfig?.validFor,
          }}
        />
      </Typography>
      <Button
        variant="contained"
        fullWidth
        onClick={() => window.open(CampaignUserStore.bogoCampaignBuyProducts?.[0].url ?? undefined, '_blank')}
      >
        <Trans
          i18nKey="coreloyalty.cashback.shopNow"
          defaults="Shop now"
        />
      </Button>
    </Box>
  );
};
export default observer(BogoCampaign);
